import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {ScoresListWidgetState} from "./models/scores-list-widget.state";
import {ScoresListWidgetConfig} from "./scores-list-widget.config";
import {PartialGameDomainModel} from "../../domain/partial-game/models/partial-game-domain-model";
import {DatetimeUtils} from "../../infrastructure/utils/datetime-utils";
import {PartialGameDataSource} from "../../domain/partial-game/models/partial-game-data-source";
import {GameCardViewModel} from "../../core/components/game-card/view-models/game-card.view-model";

export class ScoresListWidgetStore extends BaseMobxStore {
  state: ScoresListWidgetState;
  config: ScoresListWidgetConfig;
  datetimeUtils: DatetimeUtils;

  static injectables = [ScoresListWidgetConfig, ScoresListWidgetState, DatetimeUtils];

  constructor(config: ScoresListWidgetConfig, vm: ScoresListWidgetState, datetimeUtils: DatetimeUtils) {
    super(config, vm);

    this.datetimeUtils = datetimeUtils;
    this.state.registerAutorun(() => this.state.dataSource && this.setGames(this.state.dataSource));
    this.state.registerAutorun(() => this.updateGamesOddsType(this.state.appState.currentOddsType));
  }

  setGames(dataSource: PartialGameDataSource) {
    const isValid = dataSource && dataSource.games;
    const hasGames = dataSource.games.length > 0;

    if (!isValid || !hasGames) {
      return;
    }

    this.updateGames(dataSource);
  }

  clearGames() {
    this.state.gamesVM.length = 0;
  }

  updateGamesOddsType(oddsType) {
    this.state.gamesVM.forEach((game: GameCardViewModel) => game.oddsType = oddsType);
  }

  updateGames(model: PartialGameDataSource) {
    this.oddsType = this.state.appState.currentOddsType;

    const gamesVM = model.games.map((gameDomainModel: PartialGameDomainModel) => {
      let game: GameCardViewModel = this.state.gamesVM.find((game: GameCardViewModel) => game.id === gameDomainModel.id);

      if(game) {
        game.domainModel = gameDomainModel;
        const date: String = this.datetimeUtils.toShortDate(gameDomainModel.startTime);
        const time: String = this.datetimeUtils.toShortTime(gameDomainModel.startTime);

        game.date = date;
        game.time = time;
        game.terms = this.state.terms;

        game.createAnimation(game.domainModel.animation);

        return null;
      } else {
        const date: String = this.datetimeUtils.toShortDate(gameDomainModel.startTime);
        const time: String = this.datetimeUtils.toShortTime(gameDomainModel.startTime);
        const game = new GameCardViewModel(gameDomainModel, this.state.terms, this.state.device.isSmallView, date, time, this.oddsType);

        game.createAnimation(game.domainModel.animation);

        return game;
      }
    }).filter(x => !!x);

    this.state.gamesVM.push(...gamesVM);
  }

  setIsLive(isLive: Boolean) {
    this.state.isLive = isLive;
  }

  setScrollToGameId(gameId: Number) {
    this.state.scrollToGameId = gameId;
  }

  clearScrollToGameId() {
    this.state.scrollToGameId = null;
  }
}

